module.exports = __webpack_public_path__ + "static/images/deleteTemplateIconDisabled.8276296e.svg";